import { render, staticRenderFns } from "./ignore-period-cell-renderer.vue?vue&type=template&id=4a5f1b6a&scoped=true"
import script from "./ignore-period-cell-renderer.vue?vue&type=script&lang=js"
export * from "./ignore-period-cell-renderer.vue?vue&type=script&lang=js"
import style0 from "./ignore-period-cell-renderer.vue?vue&type=style&index=0&id=4a5f1b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f1b6a",
  null
  
)

export default component.exports